import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ActionsService {
  constructor(private http: HttpClient) {}
  getAllActions(params: any): Observable<ApiResponse> {
    return this.http.get<ApiResponse>('/v1/admin/actions', { params });
  }

  changeSequence(data: any): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`/v1/admin/actions/updateSequence/`, { data });
  }

  updateVisibility(data: any): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`/v1/admin/actions`, { data });
  }

  exportAction(params: any) {
    const options = {
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
      params,
    };
    return this.http.post<HttpResponse<Blob>>('/v1/admin/actions/export-actions', params, options);
  }
}
